// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Anything above large phones */
@media screen and (min-width: 575px) {
  .App {
    margin-top: 10px;
    width: 100%;
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  header {
    width: 550px;
    display: flex;
    justify-content: space-between;
  }

  .headerLogo {
    display: inline-flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: calc(10px + 4vmin);
    font-weight: bold;
  }

  .about {
    display: flex;
    justify-content: right;
    align-items: center;
  }

  header img {
    width: 50%;
  }

  .colorHead {
    color: #4CAF50;
  }

  form {
    margin-top: 15px;
    width: 550px;
  }

  .position-input {
    width: 30px;
    height: 30px;
    font-size: calc(10px + 2vmin);
    text-align: center;
    margin-left: 10px;
  }
  
  #pos1 {
    margin-left: 10px;
  }
  
  .include-input {
    margin-top: 15px;
    width: 205px;
    height: 30px;
    font-size: calc(10px + 2vmin);
    margin-top: 10px;
    margin-left: 10px;
  }

  .exclude {
    margin-top: 20px;
    border: 1px solid white;
  }
  
  h4 {
    margin: 2% 0% 2% 2%;
    font-weight: normal;
  }
  
  .excludeAll {
    margin-bottom: 2%;
  }
  
  .exclude-input {
    width: 325px;
    height: 30px;
    font-size: calc(10px + 2vmin);
    margin-left: 10px;
    margin-top: 5px;
  }
  
  .excludeByLetter {
    font-size: calc(10px + 2vmin); 
    margin: 10px 0 10px 10px;
  }
  
  .exLetter {
    height: 30px;
    width: 100px;
    font-size: calc(10px + 2vmin);
    margin: 0 15px 0 10px;
  }
  
  .button-container {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  
  .button {
    width: 125px;
    display: flex;
    flex-wrap: nowrap;
    margin: 10px;
    padding: 10px;
    font-size: calc(10px + 2vmin);
    font-weight: bold;
    cursor: pointer;
    justify-content: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #4CAF50;
    border: none;
    border-radius: 10px;
    box-shadow: 0 2.5px rgb(201, 193, 193);
  }
  
  .button:hover {background-color: #4CAF50}
  
  .button:active {
    background-color: #3e8e41;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  }

  .wordcount {
    margin-top: 15px;
    display: flex;
    justify-content: center;
  }

  .wordlist {
    display: flex;
    width: 550px;
    
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
  }
  
  .word {
    margin: 20px;
  }

  .about-page {
    font-size: calc(10px + 1.5vmin);
    width: 575px;
    margin-bottom: 50px;
  }

  .about-block {
    margin: 4% 2% 2% 2%;
  }

}

/* iPhone 14 Pro Max and Below */
@media screen and (max-width: 430px) {
  .App {
    width: 100%;
    background-color: #282c34;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }
  header {
    width: 97%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headerLogo {
    display: inline-flex;
    flex-direction: row;
    align-items: flex-start;
    font-size: calc(10px + 4vmin);
    margin: 2%;
    font-weight: bold;
  }

  .about {
    display: flex;
    justify-content: right;
    align-items: center;
    margin: 2%;
  }

  header img {
    width: 50%;
  }

  .colorHead {
    color: #4CAF50;
  }
  
  form {
    margin: 3%
  }

  .position-input {
    width: 4%;
    height: 20px;
    font-size: calc(10px + 1.5vmin);
    text-align: center;
    margin-left: 1.5%;
  }
  
  #pos1 {
    margin-left: 5%;
  }
  
  .include-input {
    width: 50.5%;
    height: 20px;
    font-size: calc(10px + 1.5vmin);
    margin-left: 2%;
    margin-top: 3%;
  }
  
  /* Exclusion Section Styling */ 
  .exclude {
    margin-top: 5%;
    border: 1px solid white;
  }
  
  h4 {
    margin: 2% 0% 2% 2%;
    font-weight: normal;
  }
  
  .excludeAll {
    margin-bottom: 2%;
  }
  
  .exclude-input {
    width: 59%;
    height: 20px;
    font-size: calc(10px + 1.5vmin);
    margin-left: 2%;
    margin-top: 1%;
  }
  
  .excludeByLetter {
    font-size: calc(10px + 1.5vmin); 
    margin: 3% 0% 2% 2%;
  }
  
  .exLetter {
    width: 15%;
    font-size: calc(10px + 1.5vmin);
    margin: 0 4.2% 0 2%;
  }
  
  .button-container {
    display: flex;
    justify-content: center;
  }
  
  .button {
    width: 32%;
    display: flex;
    flex-wrap: nowrap;
    margin: 3%;
    padding: 3%;
    font-size: calc(10px + 2vmin);
    font-weight: bold;
    cursor: pointer;
    justify-content: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #4CAF50;
    border: none;
    border-radius: 10px;
    box-shadow: 0 2.5px rgb(201, 193, 193); 
  }
  
  .button:hover {background-color: #4CAF50}
  
  .button:active {
    background-color: #3e8e41;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  }
  
  .wordcount {
    display: flex;
    justify-content: center;
  }

  .wordlist {
    display: flex;
    width: 90%;
    margin: 2% 2% 2% 5%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
  }
  
  .word {
    margin: 4%;
  }
  
  .about-page {
    font-size: calc(10px + 1.5vmin);
    width: 97%;
    margin-bottom: 15%;
  }

  .about-block {
    margin: 5% 2% 2% 2%;
  }

}





`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA,eAAe,yBAAyB;;EAExC;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,YAAY;;IAEZ,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;AAEA,gCAAgC;AAChC;EACE;IACE,WAAW;IACX,yBAAyB;;IAEzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;EACF;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA,eAAe,yBAAyB;;EAExC;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;AAEF","sourcesContent":["/* Anything above large phones */\n@media screen and (min-width: 575px) {\n  .App {\n    margin-top: 10px;\n    width: 100%;\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n\n  header {\n    width: 550px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .headerLogo {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: flex-start;\n    font-size: calc(10px + 4vmin);\n    font-weight: bold;\n  }\n\n  .about {\n    display: flex;\n    justify-content: right;\n    align-items: center;\n  }\n\n  header img {\n    width: 50%;\n  }\n\n  .colorHead {\n    color: #4CAF50;\n  }\n\n  form {\n    margin-top: 15px;\n    width: 550px;\n  }\n\n  .position-input {\n    width: 30px;\n    height: 30px;\n    font-size: calc(10px + 2vmin);\n    text-align: center;\n    margin-left: 10px;\n  }\n  \n  #pos1 {\n    margin-left: 10px;\n  }\n  \n  .include-input {\n    margin-top: 15px;\n    width: 205px;\n    height: 30px;\n    font-size: calc(10px + 2vmin);\n    margin-top: 10px;\n    margin-left: 10px;\n  }\n\n  .exclude {\n    margin-top: 20px;\n    border: 1px solid white;\n  }\n  \n  h4 {\n    margin: 2% 0% 2% 2%;\n    font-weight: normal;\n  }\n  \n  .excludeAll {\n    margin-bottom: 2%;\n  }\n  \n  .exclude-input {\n    width: 325px;\n    height: 30px;\n    font-size: calc(10px + 2vmin);\n    margin-left: 10px;\n    margin-top: 5px;\n  }\n  \n  .excludeByLetter {\n    font-size: calc(10px + 2vmin); \n    margin: 10px 0 10px 10px;\n  }\n  \n  .exLetter {\n    height: 30px;\n    width: 100px;\n    font-size: calc(10px + 2vmin);\n    margin: 0 15px 0 10px;\n  }\n  \n  .button-container {\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .button {\n    width: 125px;\n    display: flex;\n    flex-wrap: nowrap;\n    margin: 10px;\n    padding: 10px;\n    font-size: calc(10px + 2vmin);\n    font-weight: bold;\n    cursor: pointer;\n    justify-content: center;\n    text-decoration: none;\n    outline: none;\n    color: #fff;\n    background-color: #4CAF50;\n    border: none;\n    border-radius: 10px;\n    box-shadow: 0 2.5px rgb(201, 193, 193);\n  }\n  \n  .button:hover {background-color: #4CAF50}\n  \n  .button:active {\n    background-color: #3e8e41;\n    box-shadow: 0 5px #666;\n    transform: translateY(4px);\n  }\n\n  .wordcount {\n    margin-top: 15px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .wordlist {\n    display: flex;\n    width: 550px;\n    \n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    align-items: center;\n  }\n  \n  .word {\n    margin: 20px;\n  }\n\n  .about-page {\n    font-size: calc(10px + 1.5vmin);\n    width: 575px;\n    margin-bottom: 50px;\n  }\n\n  .about-block {\n    margin: 4% 2% 2% 2%;\n  }\n\n}\n\n/* iPhone 14 Pro Max and Below */\n@media screen and (max-width: 430px) {\n  .App {\n    width: 100%;\n    background-color: #282c34;\n    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n  header {\n    width: 97%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .headerLogo {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: flex-start;\n    font-size: calc(10px + 4vmin);\n    margin: 2%;\n    font-weight: bold;\n  }\n\n  .about {\n    display: flex;\n    justify-content: right;\n    align-items: center;\n    margin: 2%;\n  }\n\n  header img {\n    width: 50%;\n  }\n\n  .colorHead {\n    color: #4CAF50;\n  }\n  \n  form {\n    margin: 3%\n  }\n\n  .position-input {\n    width: 4%;\n    height: 20px;\n    font-size: calc(10px + 1.5vmin);\n    text-align: center;\n    margin-left: 1.5%;\n  }\n  \n  #pos1 {\n    margin-left: 5%;\n  }\n  \n  .include-input {\n    width: 50.5%;\n    height: 20px;\n    font-size: calc(10px + 1.5vmin);\n    margin-left: 2%;\n    margin-top: 3%;\n  }\n  \n  /* Exclusion Section Styling */ \n  .exclude {\n    margin-top: 5%;\n    border: 1px solid white;\n  }\n  \n  h4 {\n    margin: 2% 0% 2% 2%;\n    font-weight: normal;\n  }\n  \n  .excludeAll {\n    margin-bottom: 2%;\n  }\n  \n  .exclude-input {\n    width: 59%;\n    height: 20px;\n    font-size: calc(10px + 1.5vmin);\n    margin-left: 2%;\n    margin-top: 1%;\n  }\n  \n  .excludeByLetter {\n    font-size: calc(10px + 1.5vmin); \n    margin: 3% 0% 2% 2%;\n  }\n  \n  .exLetter {\n    width: 15%;\n    font-size: calc(10px + 1.5vmin);\n    margin: 0 4.2% 0 2%;\n  }\n  \n  .button-container {\n    display: flex;\n    justify-content: center;\n  }\n  \n  .button {\n    width: 32%;\n    display: flex;\n    flex-wrap: nowrap;\n    margin: 3%;\n    padding: 3%;\n    font-size: calc(10px + 2vmin);\n    font-weight: bold;\n    cursor: pointer;\n    justify-content: center;\n    text-decoration: none;\n    outline: none;\n    color: #fff;\n    background-color: #4CAF50;\n    border: none;\n    border-radius: 10px;\n    box-shadow: 0 2.5px rgb(201, 193, 193); \n  }\n  \n  .button:hover {background-color: #4CAF50}\n  \n  .button:active {\n    background-color: #3e8e41;\n    box-shadow: 0 5px #666;\n    transform: translateY(4px);\n  }\n  \n  .wordcount {\n    display: flex;\n    justify-content: center;\n  }\n\n  .wordlist {\n    display: flex;\n    width: 90%;\n    margin: 2% 2% 2% 5%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    align-items: center;\n  }\n  \n  .word {\n    margin: 4%;\n  }\n  \n  .about-page {\n    font-size: calc(10px + 1.5vmin);\n    width: 97%;\n    margin-bottom: 15%;\n  }\n\n  .about-block {\n    margin: 5% 2% 2% 2%;\n  }\n\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
